import { Tag } from "primereact/tag";

import { Dialog } from "@/ds";
import { FichasTabela } from "../fichas-tabela";
import { FinanceiroFichaViewer } from "../financeiro-ficha-viewer";
import { PREVIA_TAG } from "./financeiro-fichas-dialog.constants";
import styles from "./financeiro-fichas-dialog.module.scss";
import type { FinanceiroFichasDialogViewModel } from "./types-financeiro-fichas-dialog";

/** Moldura da modal: título (sem seta de voltar) e a listagem ou a ficha aberta. */
export function FinanceiroFichasDialogView({
  obraId,
  fichaId,
  emFicha,
  gerando,
  naListagem,
  recarregarEm,
  emPrevia,
  dialogClassName,
  titulo,
  abrirFicha,
  fechar,
  gerarFicha,
  encerrarGeracao,
  previaBloqueada,
  fichaSalva,
}: FinanceiroFichasDialogViewModel) {
  const header = (
    <div className={styles.header}>
      <div className={styles.titulo}>
        <span>{titulo}</span>
      </div>
      {emPrevia ? (
        <Tag
          value={PREVIA_TAG}
          severity="info"
          className={styles.previaTag}
          data-testid="ficha-previa-tag"
        />
      ) : null}
    </div>
  );

  return (
    <Dialog
      visible
      onHide={fechar}
      size="xl"
      className={dialogClassName}
      header={header}
      headerClassName={styles.headerLinha}
      focusOnShow={false}
      data-testid="fichas-dialog"
    >
      {emFicha && fichaId !== null ? (
        <FinanceiroFichaViewer obraId={obraId} fichaId={fichaId} />
      ) : null}

      {gerando ? (
        <FinanceiroFichaViewer
          obraId={obraId}
          onSalva={fichaSalva}
          onFechar={encerrarGeracao}
          onPreviaBloqueada={previaBloqueada}
        />
      ) : null}

      <FichasTabela
        obraId={obraId}
        oculta={!naListagem}
        recarregarEm={recarregarEm}
        onAbrir={abrirFicha}
        onGerar={gerarFicha}
      />
    </Dialog>
  );
}
